import React from 'react'
import { Menu, MenuItem, MenuItemContent } from 'builder/components/Menu'

import { LOGO_ELEMENT_ID } from 'builder/components/Navigation'

import { useMenuItems } from '../../hooks/useMenuItems'
import { Profile } from '../Profile/Profile'
import { SubMenu } from './SubMenu'
import { LeftDrawer, LogoLink, LogoStyled, LogoContainer } from './styles'

type IProps = React.HTMLAttributes<HTMLDivElement> & {
  id?: string
  isOpen: boolean
  width: string
  onClickLink?: (link: string) => void
}

const MenuComponent = ({ id, isOpen, width, onClickLink, ...rest }: IProps) => {
  const { menuItems, isActiveSubMenu } = useMenuItems()
  const promoBanner = localStorage.getItem('promoBanner')

  return (
    <LeftDrawer {...rest} id={id} width={width} isOpen={isOpen}>
      <Menu>
        <LogoContainer>
          <LogoLink
            aria-label="Logo"
            isMenuOpen={false}
            to={promoBanner === '1' ? '/?tr_promo_banner=1' : '/'}
          >
            <LogoStyled id={LOGO_ELEMENT_ID} variant={isOpen ? 'default' : 'small'} />
          </LogoLink>
        </LogoContainer>

        <Profile width={width} open={isOpen} isSubMenuActive={isActiveSubMenu} />
        {menuItems.map(item => (
          <MenuItem
            position={item.position || 'start'}
            key={item.text}
            width={width}
            subMenu={item?.subMenu && <SubMenu items={item?.subMenu} onClickLink={onClickLink} />}
          >
            <MenuItemContent
              {...item}
              open={isOpen}
              subMenu={!!item?.subMenu}
              onClickLink={onClickLink}
            >
              {item.text}
            </MenuItemContent>
          </MenuItem>
        ))}
      </Menu>
    </LeftDrawer>
  )
}

export default React.memo(MenuComponent)
